import styled from 'styled-components'

import { TradesTable } from '../../trades-table/ui/trades-table'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const TradeHistoryTable: React.FC<Props> = ({
  className,

  pair,
}) => {
  return (
    <Root className={className}>
      <TradesTable
        pairAddress={pair.address}
        onlyUserWallets={true}
        pair={pair}
      />
    </Root>
  )
}

const Root = styled.div``
